const PLN_FORMATTER = new Intl.NumberFormat('pl-PL', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

export function formatPln(value: unknown): string {
  const numeric = typeof value === 'number' ? value : Number(value ?? 0);
  const safe = Number.isFinite(numeric) ? numeric : 0;
  return `${PLN_FORMATTER.format(safe)} zł`;
}
